module.exports = __webpack_public_path__ + "static/media/whatsapp.6cfb8091.png";